import axios from '../../constants/axios';
import * as types from '../../constants/actionTypes';

export function loadProductLocationsSuccess(payload) {
   return { type: types.LOAD_PRODUCT_LOCATIONS_SUCCESS, payload: payload };
}

// export function addProductLocationCategory(payload) {
//    return {type: types.ADD_PRODUCT_LOCATION_CATEGORY, payload: payload};
// }
//
// export function addProductLocationSubCategory(payload) {
//    return {type: types.ADD_PRODUCT_LOCATION_SUB_CATEGORY, payload: payload};
// }
//
//
// //
// // export function removeProductFeature(payload) {
// //    return {type: types.REMOVE_PRODUCT_FEATURE, payload: payload};
// // }


export function loadProductLocationsById(productId) {
   return function (dispatch) {
      return axios
         .get(`items/productMain/getLocationsById/${productId}`)
         .then(function (res) {
            dispatch(loadProductLocationsSuccess({
               productLocations: res.data
            }));
         });
   };
}



/** WEBPACK FOOTER **
 ** ./src/actions/productMainEdit/productLocationActions.js
 **/